export const LegalIds = {
  owner: "ZeNotes",
  product: "ZeNotes",
  root: `${window.location.protocol}//${window.location.host}`
};

Object.freeze(LegalIds);
